/*
 * @Author: 向南星 xiangnanxing@scmagic.cn
 * @Date: 2022-09-19 13:56:15
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2022-11-04 17:48:28
 */
import { EasPopup } from '@easyvaas/react-components';
import classNames from 'classnames';
import React from 'react';
import { useRecoilState } from 'recoil';
import { imagePopupVisibleSelector } from '../../store/selector';
import ImageButton from '../ImageButton';
import styles from './index.module.scss';
interface Props {
  type: ImageV3State.PopupType;
  title: string;
  className?: string;
  confirmText?: string;
  cancelText?: string;
  children?: any;
  renderFooter?: () => JSX.Element | null | undefined | false;
  onClick?: (() => any) | false;
  customSubButton?: JSX.Element | false;
  position?: 'bottom' | 'center';
  popupClassName?: string;
  id?: string;
}
const ImageOperationPopup: React.FC<Props> = ({
  type,
  confirmText,
  cancelText,
  title,
  className,
  children,
  renderFooter,
  onClick,
  position,
  customSubButton,
  popupClassName,
  id
}) => {
  const [visible, setVisible] = useRecoilState(imagePopupVisibleSelector(type));
  return (
    <EasPopup
      visible={visible}
      onClose={() => setVisible(false)}
      className={classNames(
        styles.container,
        styles[position || 'center'],
        popupClassName
      )}
      position={position || 'center'}
    >
      <div className={styles.title}>{title}</div>
      <div className={classNames([styles.content, className])} id={id}>
        {React.Children.map(children, c => c)}
      </div>
      <div className={styles.buttons}>
        {customSubButton || (
          <ImageButton
            type="primary"
            onClick={() => setVisible(false)}
            size={position === 'bottom' ? 'large' : 'medium'}
          >
            {cancelText || '取消'}
          </ImageButton>
        )}

        {onClick && (
          <ImageButton
            type="accent"
            size={position === 'bottom' ? 'large' : 'medium'}
            onClick={onClick}
          >
            {confirmText || '确认'}
          </ImageButton>
        )}
      </div>
      {renderFooter && renderFooter()}
    </EasPopup>
  );
};

export default ImageOperationPopup;
